
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";

import { BrowserRouter } from "react-router-dom";
import 'primereact/resources/themes/lara-light-indigo/theme.css'; // Theme
import 'primereact/resources/primereact.min.css';                // Core styles
import 'primeicons/primeicons.css';                              // Icons
                                          // Tailwind

import { PrimeReactProvider } from "primereact/api";
import { create } from "zustand";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

/*scan({
	enabled: true,
  });*/
  

const queryClient = new QueryClient();

export const useBearStore = create((set) => ({
	bears: 0,
	increasePopulation: () =>
		set((state: any) => ({ bears: state.bears + 1 })),
	removeAllBears: () => set({ bears: 0 }),
}));



createRoot(document.getElementById("root")!).render(
	<PrimeReactProvider>
		<BrowserRouter>
			<QueryClientProvider client={queryClient}>
				<App />
			</QueryClientProvider>
		</BrowserRouter>
	</PrimeReactProvider>
);
